import {Component, EventEmitter, Output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'tl-company-plan',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './company-plan.component.html',
})
export class CompanyPlanComponent {
  @Output() clickToSubscribe: EventEmitter<void> = new EventEmitter<void>();
}
